import {typedQuery} from "../../typing.ts";
import api from "../../../api";

export const userWatcherPreferences = typedQuery(["watcherPreferneces"], async () => {
  return await api.watcherPreferences.get_();
});

export const accountWatcherPreferences = typedQuery(["account", "watcherPreferneces"], async () => {
  return await api.watcherPreferences.getAccount();
});
